import { LuListTodo } from "react-icons/lu";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";
import { getAllPendingTodosForEmployeeQueryOptions } from "@/config/queries/emp-query-options";

export const TodoSnippet = () => {
  const key = Cookies.get("key") as string;

  const { data } = useQuery(getAllPendingTodosForEmployeeQueryOptions(key));

  return (
    <Popover>
      <PopoverTrigger className="transition-all duration-300 hover:bg-ring/10 p-2 rounded-full">
        <LuListTodo className="w-5 h-5" />
      </PopoverTrigger>

      <PopoverContent className="mr-5 mt-0.5 p-0 bg-popover text-popover-foreground dark:bg-[#282828] max-w-96 w-[24rem] dark:border dark:border-zinc-700">
        <div className="p-5">
          <h1 className="text-[17px] font-[600] mb-2">Your Todo Status</h1>

          <p>
            You've <span className="font-bold">{data?.todos?.length}</span>{" "}
            todos to finish
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
};
